import type { FaireProductEntity } from "../../entity_types/product";

export const p_mn95k4k55w: FaireProductEntity = {
  token: "p_mn95k4k55w",
  type: "product",
  name: "Fratelli Sicilia Assorted Sicilian Cannoli",
  brandToken: "b_6cjsp5frk5",
  brandName: "Alto Imports Company",
  imageUrl:
    "https://cdn.faire.com/fastly/89938955601556cbdcf77e4c19c259485fc877f6a66bb12549945b7d66339326.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/71ef1d07c4e69b34bd9031866c4bc11c0723a916bdc37a9d574094278838af98.jpeg",
    "https://cdn.faire.com/fastly/1c0949bcb488e3801ade0fc1e428771818e821108a0cd3462a487bdb34ba8be3.jpeg",
    "https://cdn.faire.com/fastly/3a7674572a14716e51c720b77fdbd7c2f89faa13f2b73177bbb1d2241690598c.jpeg",
    "https://cdn.faire.com/fastly/9b25f18328bfd9ae7b4b493dbeb40c9633fa66e6c6fb89baecfa4dcda3c21330.jpeg",
    "https://cdn.faire.com/fastly/53d90755ed29c01a8b49607421b666862d5494102fca06524307d2080d258047.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "These Fratelli Sicilia Assorted Sicilian Cannoli are handcrafted in Sicily by MID Dolciaria using traditional pastry techniques. Each crispy cannolo shell is filled with rich Italian cream in four classic flavors: pistachio, lemon, almond, and chocolate.\n\nMade with high-quality ingredients and carefully packaged to preserve freshness, this assortment offers an elegant presentation and consistent quality for gourmet shops, Italian markets, cafés, and gift assortments.\n\nWith a long shelf life and strong consumer appeal, these cannoli are ideal for retailers seeking premium imported desserts with reliable turnover.\n\n🇮🇹 Made in Sicily, Italy\nAssorted cream fillings (Pistachio, Lemon, Almond, Chocolate)\nCrispy traditional cannoli shell\nPremium retail packaging\nShelf-stable\n12-month shelf life\nIdeal for specialty and gourmet retail\n",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:02.018Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
